import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { Page, PageHeader } from '../ui'
import { IntroducersDirectoryView } from '../components/views'

function IntroducersDirectory() {
    return (
        <div className="introducersDirectory">
            <Sidebar />
            <MainView>
                <Page>
                    <PageHeader eyebrow="Sentinel Tools" title="Introducers Directory" intro="Directory of introducer web apps: live domains, deployments, repositories and industry." />
                    <IntroducersDirectoryView />
                </Page>
            </MainView>
        </div>
    )
}

export default IntroducersDirectory
